<template>
  <div class="app-auth-shell">
    <div class="app-auth-shell__blob--primary" aria-hidden="true" />
    <div class="app-auth-shell__blob--secondary" aria-hidden="true" />

    <header class="app-auth-shell__header">
      <RouterLink to="/" class="-m-1.5 p-1.5 transition-opacity hover:opacity-80">
        <span class="sr-only">Givaroo</span>
        <img
          class="h-10 w-auto sm:h-11"
          src="../assets/givvy.png"
          alt="Givaroo kangaroo logomark"
        />
      </RouterLink>
      <NavMenu v-if="isLoggedIn" compact />
    </header>

    <Hero />
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'
import Hero from '../components/marketing/Hero.vue'
import NavMenu from '../components/NavMenu.vue'

const store = useStore()
const isLoggedIn = computed(() => store.getters.isLoggedIn)
</script>
